import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers/root-reducer";
import thunk from "redux-thunk";

/**
 * Redux Store
 * @namespace redux_store
 * @category Redux
 */

/**
 * Dependendant on NODE_ENV is responsible for react dev tools.
 * @category Redux
 * @subcategory Store
 * @memberof redux_store
 */
const reduxDevTools = process.env.NODE_ENV === "development" ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null;

/**
 * Composer for the initialization of the redux store.
 * @category Redux
 * @subcategory Store
 * @memberof redux_store
 */
const composeEnhancers = reduxDevTools || compose;

/**
 * Initialization of the redux store.
 * @category Redux
 * @subcategory Store
 * @memberof redux_store
 */
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
export default store;
